export default class BlogNavigation {
    constructor(el) {
        this.el = el;
        this.html = document.querySelector('html');
        this.body = document.querySelector('body');
        this.blogContainer = document.querySelector('.responsive-blog-nav');
        this.showSticky = document.querySelector('.blog-sticky');
        this.bind();
    }
    bind() {
        this.showBlogNav();
        this.stickyScroll();
    }
    showBlogNav() {
        if (this.blogContainer) {
            this.blogContainer.classList.add('show-blog-nav');
        }
    }
    stickyScroll() {
        if (this.showSticky) {
            window.addEventListener('scroll', () => {
                const currentScroll = window.scrollY;
                const headerHeight = this.blogContainer.offsetHeight;
                if (currentScroll > headerHeight + 100) {
                    this.blogContainer.classList.add('is-sticky');
                    this.body.querySelector('.mobile-menu-wrapper')?.classList.add('mobile-sticky');
                } else {
                    this.blogContainer.classList.remove('is-sticky');
                    this.body.querySelector('.mobile-menu-wrapper')?.classList.remove('mobile-sticky');
                }
            });
        }
    }
}
if (document.querySelector('.blog-nav')) {
    const blogNavigation = new BlogNavigation(document.querySelector('.blog-nav'));
}